import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "preact/jsx-runtime";
import { Component, render } from "preact";
import { getCurrentSchedule, preserveSchedulePayPlan } from '../api/Client';
import { PaymentMethodComponent } from "./list/PaymentMethodComponent";
import { OrdererComponent } from "./list/schedulepay/OrdererComponent";
import { PlanComponent } from "./list/schedulepay/PlanComponent";
export class SchedulePayConfirmComponent extends Component {
    constructor() {
        super();
    }
    render() {
        if (Object.entries(this.state).length > 0) {
            let payInfo = null;
            if (this.state.paymentForm) {
                const { cardBrand, cardNo, paymentMethod, paytime } = this.state.paymentForm;
                payInfo = {
                    cardBrand: cardBrand,
                    maskedCardNo: cardNo,
                    paymentMethod: paymentMethod,
                    paytime: paytime,
                };
            }
            return (_jsxs("article", { children: [_jsx(PlanComponent, { payType: this.state.payType, plan: this.state.selectedPlan, planGroup: this.state.selectedPlanGroup, quantity: this.state.quantity, storeName: this.state.storeName, multipleOption: this.state.selectedMultipleOptions, singleOption: this.state.selectedSingleOption, preserveFrom: this.state.preserveFrom, preserveTo: this.state.preserveTo }, void 0),
                    payInfo ? (_jsxs(_Fragment, { children: [_jsx(PaymentMethodComponent, { payInfo: payInfo }, void 0),
                            _jsx("div", Object.assign({ class: "flex flex__row flex__justify-content-center my2" }, { children: _jsx("a", Object.assign({ type: "button", class: "button button__secondary button__md w50", href: "/schedules/orderer" }, { children: "\u4FEE\u6B63\u3059\u308B" }), void 0) }), void 0)] }, void 0)) : null,
                    _jsx(OrdererComponent, { orderer: this.state.orderer }, void 0),
                    _jsx(SchedulePayConfirmFooterComponent, {}, void 0)] }, void 0));
        }
        return _jsx(_Fragment, {}, void 0);
    }
    componentDidMount() {
        getCurrentSchedule().then(response => {
            this.setState(response.data);
        });
    }
}
class SchedulePayConfirmFooterComponent extends Component {
    constructor() {
        super();
        this.state = {
            processing: false
        };
    }
    render() {
        return (_jsx("footer", { children: _jsx("div", Object.assign({ class: "flex flex__row flex__justify-content-center my2" }, { children: _jsx("button", Object.assign({ type: "button", class: "button button__danger button__md w50", onClick: () => { this.preserveSelectedPlan(); }, disabled: this.state.processing }, { children: this.preserveButtonLabel() }), void 0) }), void 0) }, void 0));
    }
    preserveSelectedPlan() {
        this.setState({
            processing: true
        });
        preserveSchedulePayPlan().then(response => {
            location.href = response.data.acs
                ? response.data.acs
                : `/schedules/finish/${response.data.code}`;
        }).catch(e => {
            alert(e.response.data.error);
            throw e;
        }).finally(() => {
            this.setState({
                processing: false
            });
        });
    }
    preserveButtonLabel() {
        return this.state.processing ? '処理中' : 'ご予約を確定';
    }
}
document.addEventListener('DOMContentLoaded', () => {
    const root = document.querySelector('#SchedulePayConfirmComponent');
    if (root) {
        render(_jsx(SchedulePayConfirmComponent, {}, void 0), root);
    }
});
